import { render, staticRenderFns } from "./ingredientsCalculation.vue?vue&type=template&id=c3746d52&scoped=true&"
import script from "./ingredientsCalculation.vue?vue&type=script&lang=js&"
export * from "./ingredientsCalculation.vue?vue&type=script&lang=js&"
import style0 from "./ingredientsCalculation.vue?vue&type=style&index=0&id=c3746d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3746d52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VExpandTransition,VSimpleTable,VSlider})
